import { useState, createContext, useContext } from "react";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

const ProdutosBodyContext = createContext();

const ProdutosBodyContextProvider = ({ children }) => {
  const { queryParams, setQueryParams } = useContext(QueryParamsContext);

  // tab geral
  const [barcodeType, setBarcodeType] = useState(
    [
      {
        value: "EAN13",
        label: "EAN13",
      },
      {
        value: "G",
        label: "Genérico",
      },
    ].find((e) => e.value === queryParams.tipocodigobarras)
  );
  const [zerosQuantity, setZerosQuantity] = useState({
    value: "2",
    label: "2 (ex: 0,00)",
  });
  const [usePriceTable, setUsePriceTable] = useState(
    queryParams.paramutilizatabelaprecos === "SIM"
  );
  const [allowsFixedPrice, setAllowsFixedPrice] = useState(
    queryParams.permiteprecofixo === "SIM"
  );
  const [useUniqueStockPrice, setUseUniqueStockPrice] = useState(
    queryParams.paramprecoestoqueunico === "SIM"
  );
  const [useWholesalePrice, setUseWholesalePrice] = useState(
    queryParams.paramutilizavarejoatacado === "SIM"
  );
  const [updateRealCost, setUpdateRealCost] = useState(
    queryParams.atualizacustomedio === "SIM"
  );
  const [useBalance, setUseBalance] = useState(
    queryParams.paramutilizacodigobalanca === "SIM"
  );

  const [useStockLocation, setUseStockLocation] = useState(true);

  //tab formação de custos
  const [shipment, setShipment] = useState({
    value: "A",
    label: "Acrescentar",
  });
  const [insurance, setInsurance] = useState({
    value: "A",
    label: "Acrescentar",
  });
  const [discount, setDiscount] = useState({
    value: "S",
    label: "Subtrair",
  });
  const [otherExpenses, setOtherExpenses] = useState({
    value: "A",
    label: "Acrescentar",
  });
  const [icmsSt, setIcmsSt] = useState({
    value: "A",
    label: "Acrescentar",
  });
  const [ipi, setIpi] = useState({
    value: "A",
    label: "Acrescentar",
  });
  const [pis, setPis] = useState({
    value: "I",
    label: "Ignorar",
  });
  const [cofins, setCofins] = useState({
    value: "I",
    label: "Ignorar",
  });

  // tab guias
  const [suppliers, setSuppliers] = useState(
    queryParams.guia_produtos_fornecedores === "1"
  );
  const [datasheet, setDatasheet] = useState(
    queryParams.guia_produtos_fichatecnica === "1"
  );
  const [relatedAndSimilar, setRelatedAndSimilar] = useState(
    queryParams.guia_produtos_relacionados === "1"
  );
  const [integration, setIntegration] = useState(
    queryParams.guia_produtos_integracao === "1"
  );

  return (
    <ProdutosBodyContext.Provider
      value={{
        // tab geral
        zerosQuantity,
        setZerosQuantity,
        barcodeType,
        setBarcodeType,
        useStockLocation,
        setUseStockLocation,
        useWholesalePrice,
        setUseWholesalePrice,
        useBalance,
        setUseBalance,
        usePriceTable,
        setUsePriceTable,
        allowsFixedPrice,
        setAllowsFixedPrice,
        useUniqueStockPrice,
        setUseUniqueStockPrice,
        updateRealCost,
        setUpdateRealCost,

        //tab formação de custos
        shipment,
        setShipment,
        insurance,
        setInsurance,
        discount,
        setDiscount,
        otherExpenses,
        setOtherExpenses,
        icmsSt,
        setIcmsSt,
        ipi,
        setIpi,
        pis,
        setPis,
        cofins,
        setCofins,

        // tab guias
        suppliers,
        setSuppliers,
        datasheet,
        setDatasheet,
        relatedAndSimilar,
        setRelatedAndSimilar,
        integration,
        setIntegration,

        queryParams,
        setQueryParams,
      }}
    >
      {children}
    </ProdutosBodyContext.Provider>
  );
};

export { ProdutosBodyContext, ProdutosBodyContextProvider };
